var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"ddWzup1YjpvOQkHc3GkCo"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs'

const cdpWeekUrls = {
  preview: /.*\/cdp-week-2023\/register\//,
  production: /cdpweek\.com\/register\//,
}

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  enabled: process.env.NODE_ENV !== 'development',
  tracesSampleRate: 1.0,

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // We're sending events to Sentry only from CDP Register form.
  beforeSend(event) {
    if (event.request.url.match(cdpWeekUrls.preview) || event.request.url.match(cdpWeekUrls.production)) {
      return event
    }
  },
})
